/*
 * @Description:
 * @Version: 1.0
 * @Author: xiajunchen
 * @Date: 2021-06-25 14:56:09
 * @LastEditors: ltm
 * @LastEditTime: 2023-07-17 21:19:30
 * Copyright (C) 2021 xiajunchen. All rights reserved.
 */
import { simpleRequest as q } from '@t/utils/request'

export default {
  getHomeData: data => q('/yljx/public/home', 'get', data || {}),
  login: data => q('/yljx/public/login', 'get', data || {}),
  mLogin: data => q('/yljx/public/mLogin', 'get', data || {}),
  searchData: data => q('/yljx/public/search', 'get', data || {}),
  searchData2: data => q('/yljx/public/search2', 'get', data || {}),
  getBenMingData: data => q('/yljx/public/benming', 'get', data || {}),
  getList: data => q('/yljx/public/list', 'get', data || {}),
  getSave: data => q('/yljx/public/save', 'post', data || {}),
  deleteData: data => q('/yljx/public/delete', 'get', data || {}),
  nong2yang: data => q('/yljx/public/nong2yang', 'get', data || {}),
  yang2nong: data => q('/yljx/public/yang2nong', 'get', data || {}),
  getAutoDate: data => q('/yljx/public/getAutoDate', 'get', data || {}),
  getPay: data => q('/yljx/public/pay', 'get', data || {}),
  getLunxun: data => q('/yljx/public/lunxun', 'get', data || {}),
  getLunxun2: data => q('/yljx/public/lunxun2', 'get', data || {}),
  fuzhiData: data => q('/yljx/public/fuzhi', 'get', data || {}),
  getQrcode: data => q('/yljx/public/getQrcode', 'get', data || {}),
  runyue: data => q('/yljx/public/runyue', 'get', data || {}),
  price: data => q('/yljx/public/price', 'get', data || {}),
  // 数据权限开通目录（12 项可购买权限 + 实时价格），星盘页「开通功能」优先用它
  permissionItems: data => q('/yljx/public/permissionItems', 'get', data || {}),
  // 0 元项自助开通（点报警 / 面报警等价格为 0 的项）：点一下直接开一年，
  // 未到期时后端按空操作处理，不叠加、不延长已有年份
  permissionClaim: data => q('/yljx/public/permission-claim', 'post', data || {}),
  savePrice: data => q('/yljx/public/savePrice', 'post', data || {}),
  maxDate: data => q('/yljx/public/maxDate', 'get', data || {}),
  getZuoshan: data => q('/yljx/public/getZuoshan', 'get', data || {}),
  changeUser: data => q('/yljx/public/changeUser', 'get', data || {}),
  register: data => q('/yljx/public/register', 'get', data || {}),
  h5pay: data => q('/yljx/public/h5pay', 'get', data || {}),
  saveJizhai: data => q('/yljx/public/saveJizhai', 'get', data || {}),
  saveSiren: data => q('/yljx/public/saveSiren', 'get', data || {}),
  chaxunOrder2: data => q('/yljx/public/chaxunOrder', 'get', data || {}),
  send: data => q('/yljx/public/send', 'get', data || {}),
  yanzheng: data => q('/yljx/public/yanzheng', 'get', data || {}),
  // 微信账号绑定手机号（未绑定微信的手机号账号支付前走这里完成绑定）
  telBind: data => q('/yljx/public/telBind', 'post', data || {}),
  download: data => q('/yljx/public/download', 'get', data || {}),
  sirenprice: data => q('/yljx/public/sirenprice', 'get', data || {}),

  // 用户自动择日提交信息（user_data_selection）
  addUserDataSelection: data => q('/yljx/public/user-data-selection/add', 'post', data || {}),
  listUserDataSelection: data => q('/yljx/public/user-data-selection/list', 'get', data || {}),
  // 自动择日订单（orders，type=1 优质日课 / 3 合适日课）：
  // 付款码、付款时间，以及已交付日课快照（zuoshan / result，供订单列表「查看日课」重看）
  listUserOrders: data => q('/yljx/public/user-data-selection/orders', 'get', data || {})
  // 注：审核状态（type）只能由客服/后台修改（/yljx/admin/business/user-data-selection/{id}/type）。
  // 公开侧的匿名 update-type 端点已下线，对应封装同步删除，勿再恢复。
}

// 发送短信不变
// https://www.txky-zg.com/yljx/public/send?phone=18612590493

// 手机号登录注册一体接口，返回信息和之前一致
// https://www.txky-zg.com/yljx/public/mLogin?phone=18612590493&yzm=420364
